/* Draft preview only: native bundle identity, never a simulated colour variant. */
(() => {
  document.querySelectorAll('[data-alpine-goggles-offers]:not([data-offer-bound])').forEach(root => {
    const data = JSON.parse(root.querySelector('[data-offer-data]').textContent);
    if (String(window.Shopify?.theme?.id) !== data.themeId) return;
    root.dataset.offerBound = 'true';
    const parent = root.closest('[data-alpine-style-preview]');
    const radios = [...root.querySelectorAll('input[type="radio"]')];
    root.querySelector('form')?.addEventListener('submit', event => {
      const form = event.currentTarget;
      if (root.dataset.selectedOffer !== 'single' || root.dataset.purchaseAllowed !== 'true' || form.querySelector('[name="id"]')?.value !== '47007140872388') event.preventDefault();
    });
    const button = root.querySelector('[data-offer-purchase]');
    const money = new Intl.NumberFormat('zh-TW', { maximumFractionDigits: 0 });
    const selectedFromUrl = () => new URL(location.href).searchParams.get('offer') === 'bundle' ? 'bundle' : 'single';
    function select(key, historyMode) {
      const offer = data.offers[key];
      radios.forEach(radio => { radio.checked = radio.value === key; });
      root.dataset.selectedOffer = key;
      for (const node of [root, button]) {
        node.dataset.targetProduct = offer.productId;
        node.dataset.targetVariant = offer.variantId;
        node.dataset.targetQuantity = String(offer.quantity);
      }
      root.querySelector('[data-offer-price]').textContent = 'NT$' + money.format(offer.price);
      root.querySelector('[data-offer-includes]').textContent = offer.includes;
      root.querySelector('[data-offer-notice]').textContent = offer.notice;
      const announcement = root.querySelector('[data-offer-announcement]');
      if (announcement) announcement.textContent = '總價 NT$' + money.format(offer.price) + '；' + offer.includes;
      const gate = parent.querySelector('[data-preview-purchase-gate]');
      if (gate) gate.textContent = offer.gate;
      button.disabled = key !== 'single' || root.dataset.purchaseAllowed !== 'true' || !button.form;
      button.textContent = key === 'bundle' ? '套組尚未開放購買' : button.disabled ? '尚未開放購買' : '加入購物車';
      const url = new URL(location.href);
      url.searchParams.set('offer', key);
      url.searchParams.set('variant', offer.variantId);
      if (historyMode === 'push' && url.href !== location.href) history.pushState(history.state, '', url.pathname + url.search + url.hash);
      else if (historyMode !== 'push') history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      parent.querySelectorAll('[data-style-context] a').forEach(link => {
        const destination = new URL(link.href);
        destination.searchParams.set('offer', key);
        destination.searchParams.set('variant', offer.variantId);
        link.href = destination.pathname + destination.search + destination.hash;
      });
    }
    radios.forEach(radio => radio.addEventListener('change', () => {
      if (radio.checked) select(radio.value, 'push');
    }));
    window.addEventListener('popstate', () => select(selectedFromUrl(), 'replace'));
    select(selectedFromUrl(), 'replace');
  });
})();
